// src/store.js
import { configureStore } from '@reduxjs/toolkit';
import availableDaysReducer from './features/availableDaysSlice';

const store = configureStore({
  reducer: {
    availableDays: availableDaysReducer, // Register the availableDays reducer here
  },
});




export default store;
// Placeholder reducers - replace these with your actual reducers

